<template lang="pug">
    div
        .title Pago
        v-form(ref="form")
        v-layout(row)
            v-menu.mt-3(open-on-click top)
                v-btn(slot='activator' :color='colors.primary' dark large style="margin-top: -10px;")
                    v-icon attach_money
                    v-icon arrow_forward
                v-list
                    v-list-tile(v-for='(item, index) in arrMoney' :key='index')
                        v-btn(flat @click='addBill(item.value)') {{ item.title }}
            v-text-field.title#cash-pay-input(
                :mask="mixCurrencyMask(cashPayment, 12)"
                placeholder="Ingrese efectivo recibido"
                prefix="$"
                v-model="cashPayment"
                @input="setCashPayment"
                :rules='[rules.required, rules.rounded, rules.notZero]' 
                validate-on-blur
                @keyup.enter="handleEnter($event)"
            )    
            //- )
            v-btn(color="red" icon dark @click="clearCashPayment")
                v-icon clear
        
</template>

<script>
//import Ejemplo from './example_pagarse'
import PaymentRules from '@/mixins/PaymentRules'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'cash-payment',
    props: {},
    data: function(){
        return {
            cashPayment : '',
            arrMoney: [
                { title: '$20.000', value: 20000 },
                { title: '$10.000', value: 10000 },
                { title: '$5.000', value: 5000 },
                { title: '$2.000', value: 2000 },
                { title: '$1.000', value: 1000 },
            ],
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            payment: state => state.payment,
            total:   state => state.total,
        }),
        ...mapGetters('CashDeskModule', {
            totalToPay: 'totalToPay',
        }),
    },
    methods: {
        ...mapActions('CashDeskModule', {
            setPayment: 'setPayment',
        }),

        addBill(value){
            let prevCashPayment = 0
            if(this.cashPayment !== ""){
                prevCashPayment = parseInt(this.cashPayment)
            }
            let plus =  prevCashPayment + parseInt(value)
            this.cashPayment = plus.toString()
            this.setCashPayment()
        },

        clearCashPayment(){
            this.cashPayment = ""
            this.setCashPayment()
        },

        setCashPayment: function(){
            if(this.cashPayment != '' && (parseInt(this.cashPayment) % 10) === 0 && this.cashPayment != '0'){
                this.setPayment(this.cashPayment)
            }else{
                this.setPayment('')
            }
        },
        handleEnter: function(e){
            if(isNaN(this.cashPayment) || !this.cashPayment) return
            this.$emit('confirm', this.cashPayment)
            // document.getElementById('add-payment-button').click()
        }
    },
    watch: {
        cashPayment(){
            this.$nextTick(() => this.$refs.form.validate())
        }
    },
    components: {},
    mixins: [PaymentRules, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
        document.getElementById('cash-pay-input').focus()
        this.$nextTick(() => document.getElementById('cash-pay-input').focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>
